<grid-virtual-scroll-viewport
	class="main-grid"
	[attr.aria-busy]="(sessionListDataSource.loading$ | async) ? 'true' : 'false'"
	(onScroll)="sessionListDataSource.onScroll($event)">
	<ng-container *gridVirtualFor="let rows of dataSource(); let rowIndex = index; let columnCount = columnCount; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
		@for (item of rows; track item.session_id; let itemIndex = $index) {
			<li
				class="columns"
				[attr.aria-posinset]="getAriaPosInSet(rowIndex, itemIndex, columnCount)"
				[attr.aria-setsize]="getAriaSetSize()">
				<ngx-session-card
					[session]="item"
					[submitMode]="submitMode"
					[allowSelection]="allowSelection"
					[isSelected]="isSessionSelected(item)"
					[isSubmittingSessions]="isSubmittingSessions"
					(goToSession)="goToSession($event)"
					(selectionToggled)="onSelectionToggle($event)"
				></ngx-session-card>
			</li>
		}
	</ng-container>
</grid-virtual-scroll-viewport>
